import { Permission } from "../foundation/types/permission";
import { hasPermission } from "../operations/authorization/hasPermission";
import { useAppLoaderData } from "./useAppLoaderData";

export function useHasPermission(permission: Permission, store_id?: number) {
  const user = useAppLoaderData();

  return hasPermission(permission, user, store_id);
}
